<section class="table-wrapper">
    <div class="header">
        <div class="header-tools">
            <app-table-filters title="Filtrează" [routeParams]="['type', 'byUserType']">
                <app-select-filter field="type" [options]="filterRatings" placeholder="Nota"></app-select-filter>
                <app-select-filter field="byUserType" [options]="filterByUserType" placeholder="De la"></app-select-filter>
            </app-table-filters>
        </div>
    </div>

    <div class="table-container" [nbSpinner]="isLoading" nbSpinnerStatus="primary">
        <table mat-table matSort aria-label="Users" [dataSource]="data" [matSortActive]="activeSort"
               [matSortDirection]="activeSortDirection">

            <ng-container matColumnDef="byUser">
                <th mat-header-cell *matHeaderCellDef >De la</th>
                <td mat-cell *matCellDef="let row">
                    <a *ngIf="row.byUser.type === 'driver'" [routerLink]="['/admin/drivers/view/', row.byUser._id]"><mat-icon>directions_car</mat-icon> {{row.byUser?.profile?.firstName}} {{row.byUser?.profile?.lastName}}</a>
                    <a *ngIf="row.byUser.type === 'rider'" [routerLink]="['/admin/riders/view/', row.byUser._id]"><mat-icon>person</mat-icon> {{row.byUser?.profile?.firstName}} {{row.byUser?.profile?.lastName}}</a>
                </td>
            </ng-container>

            <ng-container matColumnDef="forUser">
                <th mat-header-cell *matHeaderCellDef >Pentru</th>
                <td mat-cell *matCellDef="let row">
                    <a *ngIf="row.forUser.type === 'driver'" [routerLink]="['/admin/drivers/view/', row.forUser._id]"><mat-icon>directions_car</mat-icon> {{row.forUser?.profile?.firstName}} {{row.forUser?.profile?.lastName}}</a>
                    <a *ngIf="row.forUser.type === 'rider'" [routerLink]="['/admin/riders/view/', row.forUser._id]"><mat-icon>person</mat-icon> {{row.forUser?.profile?.firstName}} {{row.forUser?.profile?.lastName}}</a>

                </td>
            </ng-container>

            <ng-container matColumnDef="booking">
                <th mat-header-cell *matHeaderCellDef >Cursa</th>
                <td mat-cell *matCellDef="let row" >
                    <a [routerLink]="authService.userCan('reviews:view') ? ['/admin/bookings/', row.booking._id] : []">
                        #{{row.booking._id}}
                    </a>
                </td>
            </ng-container>

            <ng-container matColumnDef="rating">
                <th mat-header-cell *matHeaderCellDef >Rating</th>
                <td mat-cell *matCellDef="let row">
                    {{row.rating}}
                    <mat-icon color="rating-icon-{{row.rating <= 3 ? 'negative' : 'positive'}}">star</mat-icon>
                </td>
            </ng-container>
            <ng-container matColumnDef="tags">
                <th mat-header-cell *matHeaderCellDef >Taguri</th>
                <td mat-cell *matCellDef="let row">{{row.tags}}</td>
            </ng-container>
            <ng-container matColumnDef="text">
                <th mat-header-cell *matHeaderCellDef >Text</th>
                <td mat-cell *matCellDef="let row">{{row.text}}</td>
            </ng-container>
            <ng-container matColumnDef="createdTs">
                <th mat-header-cell *matHeaderCellDef >Data</th>
                <td mat-cell *matCellDef="let row">
                    Creare: {{row.createdTs | date: 'short'}}<br/>
                    Vizibil: {{row.visibleAfter | date: 'short'}}
                </td>
            </ng-container>


            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="cell-center">Actions</th>
                <td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()" class="cell-center">
                    <button mat-icon-button matTooltip="Sterge" (click)="delete(row._id)" class="tapp-action-button">
                        <mat-icon color="warn">delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index"></tr>
        </table>
    </div>

    <mat-paginator [length]="dataLength" [pageIndex]="activePage" [pageSize]="activeLength"
                   [pageSizeOptions]="pageSizeOptions" showFirstLastButtons>
    </mat-paginator>
</section>
